module.exports = __webpack_public_path__ + "static/media/HI_finance.d34d83cf.png";